/* tslint:disable:no-inferrable-types no-trailing-whitespace import-spacing typedef-whitespace */

import {
  Window,
  WindowType
}              from './window';

/**
 *
 * @class DocumentMetadata
 *
 * @brief base class for the "memento" of a DocumentView; this object stores enough information to save/restore
 * a view, similarly to launch a document, basically the parameters of a document.  We will have specialized
 * documents, such as file browser, search view, stringline viewer etc.  Each will have its own sub-class of
 * DocumentMetadata, so that they can save/restore themselves or be easily launched from anywhere, by providing
 * the DocumentMetadata.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2020
 *
 */
export class DocumentMetadata {

  public id:    string     = '';
  public title: string     = 'No Title';
  public icon:  string     = '';
  public type:  WindowType = WindowType.None;

  /** standard constructor */
  constructor(id: string, title: string, icon: string, type: WindowType) {

    this.id    = id;
    this.title = title;
    this.icon  = icon;
    this.type  = type;
  }

  /** save */
  public serialize(): string {

    return JSON.stringify({
      id:    this.id,
      title: this.title,
      icon:  this.icon,
      type:  this.type
    });
  }

  /** convert this element to a simplified form that can be easily serialized */
  public node(init?: any) {

    const base = {
      id:    this.id,
      title: this.title,
      icon:  this.icon,
      type:  Window.stringOfType(this.type)
    };

    return init ? {...init, ...base } : base;
  }

  /** restore */
  public deserialize(data: string|object) {

    const defaults = {
      id:    '',
      title: 'No Title',
      icon:  '',
      type:  WindowType.None
    };

    let args: any = {};

    if (typeof data === 'string') {

      args = Object.assign({}, defaults, JSON.parse(data));

    } else {

      args = Object.assign({}, defaults, data);
    }

    this.id    = args.id;
    this.title = args.title;
    this.icon  = args. icon;
    this.type  = args.type;

  }

  /** initialize this element given the data in the simplified node object */
  public fromNode(node: any) {

    /* pick out any attributes we can assign to self, sub-classes pick out their own stuff */

    this.id    = node.id;
    this.title = node.title;
    this.icon  = node.icon;
    this.type  = node.type;

  }

}
